import { ChangeEvent, ReactNode } from "react"

export enum SortDirection {
  ASC = "asc",
  DESC = "desc",
}

export enum TableCellType {
  STRING = "string",
  NUMBER = "number",
  ISO_DATE_STRING = "isoDateString",
}

export interface TableHeader {
  label: string
  type: TableCellType
  noSort?: boolean
  headerNode?: ReactNode
}

interface Cell {
  id: string
  value?: string | number | null
  node?: ReactNode
  /** @optional overrides `value` when sorting this cell's column (e.g. sort a "full name" cell by last name) */
  sortValue?: string | number | null
}

export interface SafeTypedCell extends Cell {
  value: string | number
}

export interface TableRowData {
  id: string // TODO: do we need this?
  cells: Cell[]
}

export interface SafeTypedTableRowData extends TableRowData {
  cells: SafeTypedCell[]
}

export interface TableRow {
  data: TableRowData
  onDeleteClick?: (row: TableRowData) => void
  onEditClick?: (row: TableRowData) => void
  onCheckboxChange?: (
    event: ChangeEvent<HTMLInputElement>,
    row: TableRowData,
  ) => void
  checkboxChecked?: boolean
}

export interface SafeTypedTableRow extends TableRow {
  data: SafeTypedTableRowData
}

export interface GroupHeader {
  label: ReactNode
  colSpan: number
}

export interface CheckBoxState {
  [rowId: string]: boolean
}

export interface PaginationProps {
  totalCount: number
  onPaginationChangeCb: (count: number, offset: number) => Promise<void>
  currentPage?: number
  rowsPerPage?: number
}
